module.exports = __webpack_public_path__ + "img/money.6a43cb63.svg";